import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useValidateUserExistByPhoneNumber = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post("User/ValidateUserExistByPhoneNumber", formData);
  });
  return mutation;
};
export default useValidateUserExistByPhoneNumber;
